import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleX as faSolidCircleX } from "@fortawesome/pro-solid-svg-icons";
import { faVirus as faRegularVirus } from "@fortawesome/pro-regular-svg-icons";

import FileIcon from "components/shared/FileIcon";
import UploadBar from "./UploadBar";
import MarkdownTranslation from "../../MarkdownTranslation";
import { FileData } from "../../../../@types/files";

interface UploadedFileTypes {
  file: FileData & { extension: string };
  remove(...args: unknown[]): unknown;
  storageDirectory?: string;
  isImage?: boolean;
}

function UploadedFile({
  file,
  remove,
  storageDirectory = "files",
  isImage = false,
}: UploadedFileTypes) {
  const handleRemoveClick = (e) => {
    e.preventDefault();
    const criteria = file.id ? { id: file.id } : { clientId: file.clientId };
    remove(criteria);
  };

  return (
    <div className="upload-status">
      <div className="upload-progress">
        <UploadBar progress={file.progress} state={file.state} />
      </div>
      <div className="upload-controls flex items-center">
        <div className="flex gap-2 items-center truncate">
          {file.state === "quarantine" ? (
            <>
              <FontAwesomeIcon icon={faRegularVirus} className={"fa-lg mr-2"} />
              <span className="font-bold">
                {I18n.t("js.files.uploader.error_quarantine")}
              </span>
              <span className="text-muted truncate">{file.name}</span>
            </>
          ) : (
            <>
              {isImage ? (
                <img
                  className="max-h-12 max-w-12"
                  src={`/api/storage/${storageDirectory}/${file.id}/${
                    storageDirectory === "images" ? "get/200x200" : "preview"
                  }`}
                />
              ) : (
                <FileIcon extension={file.extension} />
              )}
              <span className="text-muted truncate">{file.name}</span>
            </>
          )}
        </div>

        {file.status ? (
          <MarkdownTranslation
            translation={`js.files.uploader.error_code_${file.status}`}
          />
        ) : null}

        <a
          href="#remove"
          className="remove btn"
          onClick={handleRemoveClick}
          data-id={file.id}
          title={I18n.t("js.remove")}
        >
          <FontAwesomeIcon icon={faSolidCircleX} className={"fa-sm"} />
        </a>
      </div>
    </div>
  );
}

export default UploadedFile;
